export { default } from './TrustPilot'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/TrustPilot/index.js